import { gql } from 'graphql-tag'

import { FRAGMENT_CONVERSATION_LIST_ITEM_CONVERSATION } from './ConversationListItem.hasura'

export const FRAGMENT_CONVERSATION_LIST_CONVERSATION = gql`
  fragment ConversationListConversation on conversation {
    id
    external_uuid

    ...ConversationListItemConversation
  }
  ${FRAGMENT_CONVERSATION_LIST_ITEM_CONVERSATION}
`
